import React, { useState, useEffect } from 'react';
import { SocialLinks } from './PortfolioComponents';
import '../styles/Blog.css';

const Blog = () => {
  const [menuState, setMenuState] = useState(false);

  const toggleMenu = () => {
    setMenuState(prevState => {
      if (!prevState) return 'active';
      return prevState === 'deactive' ? 'active' : 'deactive';
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: '#fff', minHeight: '100vh', position: 'relative' }}>
      {/* Menu overlay */}
      <div className={`menu-container ${menuState}`} style={menuState ? {} : { display: 'none' }}>
        <div className="overlay" />
        <div className="menu-items">
          <ul>
            <li><a href="/" onClick={toggleMenu}>HOME</a></li>
            <li><a href="/#about" onClick={toggleMenu}>ABOUT</a></li>
            <li><a href="/#projects" onClick={toggleMenu}>PORTFOLIO</a></li>
            <li><a href="/blog" onClick={toggleMenu}>BLOG</a></li>
            <li><a href="/archive/2024/uoh/soupbg" onClick={toggleMenu}>ARCHIVE</a></li>
          </ul>
          <SocialLinks />
        </div>
      </div>

      {/* Navigation */}
      <nav id="navbar" className="bg-active">
        <div className="nav-wrapper">
          <p className="brand">
            <a href="/" style={{ color: '#fafafa', textDecoration: 'none' }}>
              Dhanush <strong>SR Kenkiri</strong>
            </a>
          </p>
          <button
            onClick={toggleMenu}
            className={menuState === 'active' ? 'menu-button active' : 'menu-button'}
            aria-label="Toggle menu"
          >
            <span />
          </button>
        </div>
      </nav>

      {/* Blog Content */}
      <article className="medium-article">
        <div className="medium-container">
          <header className="article-header">
            <h1 className="article-title">Cardano Asia Hackathon '25</h1>
            <div className="article-meta">
              <div className="author-info">
                <span className="author-name">Dhanush SR Kenkiri</span>
              </div>
              <div className="article-stats">
                <span>Nov 28, 2024</span>
                <span className="dot">·</span>
                <span>15 min read</span>
              </div>
            </div>
          </header>

          <div className="article-content">
            <p>On 28th November at 5pm, I googled the distance from Mens Hostel - I(UoH) to Kachegouda Railway Station. Google maatha showed me that it would take 40mins to reach the station. My roommate offered to book uber for me he had some credits. Since my train was departing to Bangalore at 7:05 pm(Yeah :05 is added for a reason), I thought why waste time on rapido we will go by bus till main gate of UoH and then book a bike-taxi.</p>

            <p>I started waiting for bus at and almost 10 mins passed by - But then the traffic scenario struck me, I decided to wait 5 more minutes in the bus-stop. I started to get tense then I called my roommate to check on the prizes of uber, he told me it was Rs. 80 to get to Raidurg Metro. I told him to book. That dumbo booked the taxi and didn't tell me, pappa that bike-taxi guy is standing right next to me in the bus-stop.</p>

            <p>We were awkwardly staring at each other for long time, then I called he was like "Bro, he has come(in hindi)". I asked him to send the bike number, he sent me otp! But then I went to that guy, I asked him "Uber ah?". And then after some laughter and contemplation we left to Raidurg metro station. I told anna to drive fast, but he mentioned the this is the peak time for traffic.</p>

            <h2>The Race Against Time</h2>
            
            <p>I checked the time, it was 5:34pm. Damn, I started to get thoughts of missing the train. It had already been 25 mins in the uber, usually with no traffic reaching raidurg takes around 15 mins. But, I was still near Ikea!. When I got down, I scanned the qr - I believe it was my fastest qr scan. I ran like hell.</p>

            <p>I booked my tickets to Narayanaguda - which was the nearest metro to kachegauda in Paytm. Luckily, I got on a metro sooner then I expected. But man people literally crushed me while getting in, find a way to increase efficiency for people boarding metro.</p>

            <p>Anyways, I started to get more nervous because it was already 6:10pm. My legs started paining and my heart beating faster than ever since the last time I played cricket. Suddenly, I felt time going faster than metro stops. But in order get my brain away from stress, I started to wonder why there are two metro stations for jubilee hills.</p>

            <h2>The Final Sprint</h2>

            <p>It was 6:35pm, I reached parade ground. I had to catch green line, and go Narayanaguda. But, I kinda felt its better to get a rapido from here. I opened uber(lol), I booked a bike taxi. I wasn't able to exit the metro station, It showed me to get down at narayanaguda. Then I kinda gave up on boarding the train, and started looking for bus. But, I wasn't going to give up.</p>

            <p>I got on the greenline metro, this time it was crazy empty. I got down at Narayanaguda I checked on rapido the station was just 1.2 miles from narayanaguda, it was 6:55pm already but I built some hope and started rushing. So basically, I had 10 mins. I started looking for rapido, but there was a share auto he called me "Anna randi, last thondarga". I ran, I got in.</p>

            <p>That guy was super chill, he was like "Tension nakko anna, train ekutharu". His driving reminded me of Jordindian - Fast&Furious India version video. He drived crazily, then we reached the station it was 6:59pm. I paid him, and ran to ticket booth.</p>

            <blockquote>
              <p>"Train started moving. I was at S10 boggy, I had to run till S1. Luckily, I am a regional level sprinter with 1 gold and 2 silvers in 100m dash."</p>
            </blockquote>

            <p>I asked the aunty is the kacheguda express still there, she was crazy joking with me for no reason. And then I got the ticket and ran to the train, luckily I could see the train. I ran ran ran... Just try to think of the worst thing that could have happened to me now, It happened - Train started moving.</p>

            <p>I was at S10 boggy, I had to run till S1. Luckily, I am a regional level sprinter with 1 gold and 2 silvers in 100m dash. I somehow reached, S3 boggy. I felt like the only thing missing in my whole journey till now is a girl, pulling me into the train(lmao).</p>

            <h2>The Journey Begins</h2>

            <p>I got in, the train was full af. There was no seat, even there was no place to put my bag. I kept my bag, but given my scenario in a general train. I had to keep an eye on the bag. Some uncle gave me some space to sit but that would take my eye of the bag, So i politely said no.</p>

            <p>Some sweet aunty, offered some water seeing me gasping. She told me that, they would get down at gadwall and I could take their place. Man it's hard, trust me I was standing for 3 hrs straight. Oh I didn't mention right, I got in the train by 7:05pm.</p>

            <p>First 1 hr I didn't feel anything thanks to Swati gosh ma'am to build this sword by sending out of the class. But, my I started to see the hell. To make things worse, the train stopped for 30 mins has one more train was coming in the opposite direction.</p>

            <h2>The Hackathon Begins</h2>

            <p>But, I am hungry now! I got some samosas and started working on the hackathon, I researched the hackathon past winners and analysed how we can build a compelling project. Historically I strongly believed hackathons are won with a complex industry relevant ideas made simple.</p>

            <p>That's what my focus was on, but my teammates wanted to go with a real-life iot based project. Iot based projects have shown some interests with the judges so i agreed to build with them and work around it. Our idea was simple, just automate parking with blockchain with a solution to each problem blockchain oriented.</p>

            <p>We came with a solution for hardware and software hybrid solution, with 7 agents hybrid orchestration. I made some homework on AI agents and some technical architecture, watched lyzr ai agents demo youtube video.</p>

            <h2>Arrival in Bangalore</h2>

            <p>Finally I reached KSR jn, I noticed seats next to me where still occupied with men although the whole train was closely empty - That's when i saw a girl sitting there. Men will be men, for the record she was with someone who was guarding her.</p>

            <p>Going ahead, I got down in the station and I felt chill. It had been 4 months since I came to Bengaluru, And only one thing was flowing through me "I am home" vibe.</p>

            <p>Then I called my brother who was going to get my laptop for the hackathon, but turns out he was in the wrong station. Since it was already 7:20 pm(train got delayed an hr), and the check in for the hackathon was 9pm I told him to come directly to Pattandur Agrahara metro station.</p>

            <h2>The Den Hotel Experience</h2>

            <p>Anyways, the hotel was splendid. The den has to be one of my best hotel hackathon visit, the staff where supper friendly and they guided me so professionally. Either way, i checked in and our hall was 2 floors bellow. While I was getting down, I crashed on Anshul we shared a hug and continued to our hall and sharing some pleasantries.</p>

            <p>Everything, was fine until I noticed we where given seats at the corner of the hall I talked to one of the volunteers who was supper sweet for the record and got in place at the middle of the hall.</p>

            <h2>Building the Project</h2>

            <p>Then we wanted to start hacking asap because all of our planning was done already. But the hotel staff seriously underestimated wifi capacity and the wifi was completely not working volunteers calmed us down and where not sure on when they will get back to us.</p>

            <p>We went on with our idea, after 2hrs of misshap they had to setup 3 more routers and get the internet back. Then we started our work, I was high on caffeine it was already my 3rd day with no sleep. I was hustling through my work with just sleep running in the back, Anshul was working on the hardware and Debjit on some good ui designs.</p>

            <p>We took less breaks, and just put in everything we have into our tasks. Within no time it was lunch time, Since one person from the team should always be at the table. Me and Anshul went for lunch, we had some well made chicken and fish.</p>

            <blockquote>
              <p>"I was high on caffeine it was already my 3rd day with no sleep. I was hustling through my work with just sleep running in the back."</p>
            </blockquote>

            <p>I grabbed 3 cokes and started building, I went setting up docker and coordinating the agentic orchestration with the help of crew agents and created an http request protocol to coordinate with the frontend. Everything was going good, we had some great people surrounding us, one team from another team who was from spain - She was supper sweet and told us her story from west Bengal to spain, and how she hustled has a teacher.</p>

            <h2>Checkpoint and Challenges</h2>

            <p>It was dinner time already, and I had almost completed 70% of my work. Anshul had setup the sensor and pi and was almost complete with his work and debjit had setup some ui components and followed my tips to integrate some components from reactbits to make the ui stand out.</p>

            <p>The hackathon experience was brought back again after the wifi issue, and everyone was hoked into building something. Later on we went to build on our projects, it was the time for first checkpoint where judges will record our progress and score it.</p>

            <p>Our team was last for some reason, and we had our mentor he asked us some questions and we went on to explain we stumbled and stuttered here and there but overall we where happy that we where able to show progress.</p>

            <p>Anshul and I had a conversation regarding pitch interruptions, We had a argument where i noticed my anger was into him - I apologized later though. We learned we still had that communication issue and we promised ourselves to not make the same mistakes next time.</p>

            <h2>The Final Push</h2>

            <p>We had some cool vibe setup, with new team coming in at night with cool games. But still only thing that was pushing me is caffeine and I was out of it. Luckily Yukta(Girl from spain) offered coke, and I was back to coding again with again caffeine pushing me in.</p>

            <p>I had a call from my parents, who were upset that i didn't visit them even though i was in Bangalore. My parents are understanding, and loved my vibe in the video call. The only thing that my father told was wish I was young to be at that place.</p>

            <p>Going forward, we where all exhausted everyone was asleep but we three where pushing. We had some late night snacks, and again fueled myself with a strong coffee and went on to play pool.</p>

            <p>Anyways, it was 4 in the morning already. I took a nap at the party hall, and we had some check point at 7pm. We started working again, I skipped the breakfast and geared up for the last sprint and second checkpoint.</p>

            <h2>Submission and Results</h2>

            <p>Although individually everything was working we had to bridge everything with http requests. Later on we went on to bridge it and everything was streamlined perfectly. We tested the app and it felt like we created a new life form.</p>

            <p>We had our 2nd checkpoint with a mentor who had mentored me in the past as well. This checkpoint we made sure to not mess-up and we didn't mess up but the power did, the power was cutoff and without power the pi wasn't going to run. But mentor was understanding and just evaluated our Masumi transactions.</p>

            <p>Later on, it was our final submission and we submitted! Finally, time to not think about anything but grateful to ourselves for giving such wonderful efforts. We congratulated everyone for making till here.</p>

            <p>We went on to stretch our legs, and connect with NMKR Ceo - Patrick and Sri Charan from Neucast who knew me before as well. Patrick, liked our idea so much and went on to mention that it had chances of winning if you deploy on sukusomi and make a good final presentation.</p>

            <blockquote>
              <p>"We made it to top-10 (7th position). Which was well earned, given our track has 107 teams."</p>
            </blockquote>

            <p>Finally it was result time, unfortunately we didn't make it top 5. But we made it to top-10(7th position[Insider News]). Which was a well earned, given our tranck has 107 teams. But yukta's team made it top 5, we congratulated her.</p>

            <h2>Journey Home</h2>

            <p>I had my return booked by 7pm and had to leave has it was already 5pm, I wished luck to Yukta and had some final greeting with a team built from real strangers with some memories to remember.</p>

            <p>I went out, had some good conversation about my performance and feedback with masumi and cardano team. And rushed to metro, debjit was with me and we had our final goodbyes.</p>

            <p>I called my brother, who wanted the laptop and my mom came to see me - I told her I will back in a couple of days for IBW and stay at bangalore for 30 more days. This time I had a proper train booked with proper seating plant(lmao).</p>

            <p className="conclusion">Concluding my journey, this was an adventure I hopted. I had my final sem exams and I had all the reasons in the world but the passion that Anshul showed and my love towards building something pushed me to be part of this great hackathon. Winning is one thing and learning is the other, Still long way ahead I would tell myself!</p>

            <div className="author-signature">
              <p>Written by,<br/><strong>DSRK</strong></p>
            </div>

            <div className="medium-cta">
              <a 
                href="https://medium.com/@dh.win.1111/caffeine-chaos-cardano-341001b5903c" 
                target="_blank" 
                rel="noopener noreferrer"
                className="medium-button"
              >
                <i className="fab fa-medium"></i>
                Read on Medium
              </a>
            </div>
          </div>
        </div>
      </article>

      {/* Footer - Compact Version */}
      <footer style={{ padding: '3rem 0 2rem' }}>
        <div className="wrapper" style={{ padding: '0 2rem' }}>
          <h3 style={{ fontSize: '1.4rem', marginBottom: '0.8rem' }}>THANKS FOR VISITING</h3>
          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>© 2020 - {new Date().getFullYear()} Made with 🧡 - DSRK</p>
          <SocialLinks />
        </div>
      </footer>
    </div>
  );
};

export default Blog;
